'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _style = require('styled-jsx/style');
var _style2 = _interopRequireDefault(_style);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _base = require('../base');
var _base2 = _interopRequireDefault(_base);
var _defaultProps = require('../default-props');
var _defaultProps2 = _interopRequireDefault(_defaultProps);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ArrowReverse = function (_React$Component) {
  (0, _inherits3.default)(ArrowReverse, _React$Component);
  function ArrowReverse() {
    (0, _classCallCheck3.default)(this, ArrowReverse);
    return (0, _possibleConstructorReturn3.default)(this, (ArrowReverse.__proto__ || Object.getPrototypeOf(ArrowReverse)).apply(this, arguments));
  }
  (0, _createClass3.default)(ArrowReverse, [{
    key: 'render',
    value: function render() {
      var width = this.props.width * .2;
      return _react2.default.createElement(_base2.default, (0, _extends3.default)({
        typeClassName: 'BurgerArrowReverse'
      }, this.props), _react2.default.createElement(_style2.default, {
        styleId: '3012389544',
        css: '.BurgerArrowReverse.BurgerActive .BurgerInner:before{-webkit-transform:translate3d(' + width + 'px,0,0) rotate(45deg) scale(0.7,1);-ms-transform:translate3d(' + width + 'px,0,0) rotate(45deg) scale(0.7,1);transform:translate3d(' + width + 'px,0,0) rotate(45deg) scale(0.7,1);}.BurgerArrowReverse.BurgerActive .BurgerInner:after{-webkit-transform:translate3d(' + width + 'px,0,0) rotate(-45deg) scale(0.7,1);-ms-transform:translate3d(' + width + 'px,0,0) rotate(-45deg) scale(0.7,1);transform:translate3d(' + width + 'px,0,0) rotate(-45deg) scale(0.7,1);}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9hcnJvdy1yZXZlcnNlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVV1QixBQUdrRyxBQUdDLDJRQUYxRixHQUdBIiwiZmlsZSI6Ii4uLy4uL3NyYy90eXBlcy9hcnJvdy1yZXZlcnNlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuXG5pbXBvcnQgQmFzZSBmcm9tICcuLi9iYXNlJ1xuaW1wb3J0IGRlZmF1bHRQcm9wcyBmcm9tICcuLi9kZWZhdWx0LXByb3BzJ1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBBcnJvd1JldmVyc2UgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnR7XG5cdHJlbmRlcigpe1xuXHRcdGxldCB3aWR0aCA9IHRoaXMucHJvcHMud2lkdGggKiAuMlxuXHRcdHJldHVybiAoXG5cdFx0XHQ8QmFzZSB0eXBlQ2xhc3NOYW1lPSdCdXJnZXJBcnJvd1JldmVyc2UnIHsuLi50aGlzLnByb3BzfT5cblx0XHRcdFx0PHN0eWxlIGpzeCBnbG9iYWw+e2Bcblx0XHRcdFx0XHQuQnVyZ2VyQXJyb3dSZXZlcnNle1xuXHRcdFx0XHRcdFx0Ji5CdXJnZXJBY3RpdmV7XG5cdFx0XHRcdFx0XHRcdC5CdXJnZXJJbm5lciB7XG5cdFx0XHRcdFx0XHRcdFx0JjpiZWZvcmUge1xuXHRcdFx0XHRcdFx0XHRcdFx0dHJhbnNmb3JtOiB0cmFuc2xhdGUzZCgke3dpZHRofXB4LCAwLCAwKSByb3RhdGUoNDVkZWcpIHNjYWxlKDAuNywgMSk7XG5cdFx0XHRcdFx0XHRcdFx0fVxuXG5cdFx0XHRcdFx0XHRcdFx0JjphZnRlciB7XG5cdFx0XHRcdFx0XHRcdFx0XHR0cmFuc2Zvcm06IHRyYW5zbGF0ZTNkKCR7d2lkdGh9cHgsIDAsIDApIHJvdGF0ZSgtNDVkZWcpIHNjYWxlKDAuNywgMSk7XG5cdFx0XHRcdFx0XHRcdFx0fVxuXHRcdFx0XHRcdFx0XHR9XG5cdFx0XHRcdFx0XHR9XG5cdFx0XHRcdFx0fVxuXHRcdFx0XHRgfTwvc3R5bGU+XG5cdFx0XHQ8L0Jhc2U+XG5cdFx0KVxuXHR9XG59XG5cbkFycm93UmV2ZXJzZS5kZWZhdWx0UHJvcHMgPSBkZWZhdWx0UHJvcHMiXX0= */\n/*@ sourceURL=../../src/types/arrow-reverse.js */',
        dynamic: [width, width]
      }));
    }
  }]);
  return ArrowReverse;
}(_react2.default.Component);
exports.default = ArrowReverse;
ArrowReverse.defaultProps = _defaultProps2.default;
module.exports = exports['default'];